import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { Link } from 'react-router-dom'
import T from 'i18n-react'

export default class NavigationPanel extends React.Component {
	static propTypes = {
		className: PropTypes.string,
		disabled: PropTypes.bool,
		disabledClassName: PropTypes.string,
		onClick: PropTypes.func,
		step: PropTypes.number,
		steps: PropTypes.array,
	}

	static defaultProps = {
		className: 'step-num',
		disabled: false,
		disabledClassName: '',
		onClick: () => null,
		step: 1,
		steps: ['/']
	}

	render() {
		let prevStepUrl = '/'
		let nextStepUrl = '/'
		if (this.props.step - 1 >= 0) {
			prevStepUrl = this.props.step > 0 ? this.props.steps[this.props.step - 2] : '/'
			nextStepUrl = this.props.steps[this.props.step - 1]
		}

		const steps = this.props.steps.map((item, index) => {
			index++
			const linkClassNames = classNames({
				'nav-link': true,
				'done': index < this.props.step,
				'active': index === this.props.step,
			})
			const liClassNames = classNames({
				'nav-item': true,
				'current-item': index === this.props.step,
			})
			if (index >= this.props.step) {
				return (
					<li className={liClassNames} key={item}>
						<a className={linkClassNames}>
							<span className={this.props.className}></span>
						</a>
					</li>
				)
			}
			return (
				<li className={liClassNames} key={item}>
					<Link
						className={linkClassNames}
						to={item}
					>
						<span className={this.props.className}></span>
					</Link>
				</li>
			)
		})

		return (
			<div
				className='steps'
				id={this.props.step === 1 ? 'initialStep' : 'functionalStep'}
			>
				<ul className='nav nav-progressbar text-center'>
					<li className="d-md-none">
						<Link to={prevStepUrl}>
							<button
								className='progressbar-mobile-nav prev'
								name='button'
								type='button'
							>
								<span>◤</span>
							</button>
						</Link>
					</li>
					{steps}
					<li className="d-md-none">
						<Link to={nextStepUrl}>
							<button
								className='progressbar-mobile-nav next'
								type='button'
							>
								<span>◥</span>
							</button>
						</Link>
					</li>
				</ul>
			</div>
		)
	}
}
